// ─── 상위 이용자 TOP 8 테이블 ────────────────────────────────────────────────
import React, { useMemo } from 'react';

export default function TopUsersTable({ rows }) {
  const users = useMemo(() => {
    const m = {};
    rows.forEach((r) => {
      const k = r.user_id;
      if (!k || k === '—') return;
      if (!m[k]) m[k] = { name: r.user_name, company: r.company_name || r.company_code, cnt: 0, ok: 0 };
      m[k].cnt++;
      if (r.answer_status === 'success') m[k].ok++;
    });
    return Object.values(m).sort((a, b) => b.cnt - a.cnt).slice(0, 8);
  }, [rows]);

  if (!users.length)
    return <p className="py-8 text-center text-sm text-gray-400">데이터 없음</p>;

  const maxCnt = users[0].cnt;

  const rateColor = (u) => {
    if (!u.cnt) return '#9ca3af';
    const r = u.ok / u.cnt;
    if (r >= 0.9) return '#059669';
    if (r >= 0.7) return '#d97706';
    return '#ef4444';
  };

  return (
    <div className="space-y-4">
      {users.map((u, i) => (
        <div key={i} className="flex items-center gap-3">
          {/* 순위 */}
          <span className="shrink-0 text-center text-sm font-bold text-gray-300" style={{ width: '18px' }}>
            {i + 1}
          </span>

          {/* 이름 + 바 + 회사 */}
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2" style={{ marginBottom: '4px' }}>
              <span className="truncate text-base font-semibold text-gray-800">{u.name}</span>
              <span className="shrink-0 text-sm text-gray-400">{u.cnt}건</span>
            </div>
            {/* 프로그레스 바 */}
            <div
              className="overflow-hidden rounded-full bg-gray-100"
              style={{ height: '8px' }}
            >
              <div
                className="rounded-full bg-blue-400"
                style={{ height: '8px', width: `${(u.cnt / maxCnt) * 100}%` }}
              />
            </div>
            <p className="truncate text-sm text-gray-400" style={{ marginTop: '3px' }}>{u.company}</p>
          </div>

          {/* 성공률 */}
          <span
            className="shrink-0 text-base font-bold"
            style={{ width: '44px', textAlign: 'right', color: rateColor(u) }}
          >
            {u.cnt ? `${((u.ok / u.cnt) * 100).toFixed(0)}%` : '—'}
          </span>
        </div>
      ))}
    </div>
  );
}
